'use client';

import { WritableAtom, atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { FavoritesSort } from '@/app/[abTest]/[locale]/(spreadshirt)/favorites/components/FavoritesSortDrawer';

export function atomWithToggle(initialValue?: boolean): WritableAtom<boolean, [boolean?], void> {
  const anAtom = atom(initialValue, (get, set, nextValue?: boolean) => {
    const update = nextValue ?? !get(anAtom);
    set(anAtom, update);
  });

  return anAtom as WritableAtom<boolean, [boolean?], void>;
}

export const basketAtom = atom(false);
export const headerPageOverlayAtom = atom(false);
export const loadingOverlayAtom = atom(false);
export const mpProductGridLoadingAtom = atom(false);
export const secondLevelOpenAtom = atom(false);
export const countrySwitcherAtom = atom(false);
export const userSessionAtom = atom<UserSession | null>(null);
export const expressCheckoutLoadingAtom = atom(false);
export const embroideryProductKeyAtom = atom<string | null>(null);
export const showEmbroideryOnDetailPageAtom = atom(false);
export const pdpGalleryOffsetDurationAtom = atom(0);
export const favoritesSortingAtom = atomWithStorage<FavoritesSort>(
  'favorites_sort',
  'recentlyAdded'
);
export const ratingAccordionToggle = atomWithToggle(false);
